import React from "react";
import { Link } from "react-router-dom";
import "../../assets/styles/component/restrictedAccess.scss";

interface Props {
    onRequestAccess: (e: React.MouseEvent) => void;
}

export const RestrictedAccess = ({ onRequestAccess }: Props) => (
    <div className="primary_tile_background restricted_access_container">
        <div >
            <h3 className="error_msg no_data">Access to this dashboard is currently restricted.</h3>
            <Link className="access_link" to="#" onClick={onRequestAccess}>
                Request access
            </Link>
        </div>
    </div>
);